import React from "react";
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import "./TermsOfUse.css";

const TermsOfUse = (props) => {
  return (
    <>
    <Header en="/terms-of-use" fr="/conditions-d-utilisation" lang="en" />
    <div className="container mainDiv ab">
      <div className="row">
        <div className="col-xs-12 content">
          <h1 className="terms-of-use">Terms Of Use</h1>
          <div>
            <p>Welcome to <b>Travelance Inc</b> ("Travelance", "we", "us", or "our"). These <b>Terms of Use</b> ("Terms") govern your access to and use of Travelance.ca and its associated services, including our quote generation software, broker portal, and insurance product platform (collectively, the "Services").</p>
            <p>By accessing or using our Services, you acknowledge that you have read, understood, and agreed to be bound by these Terms and our Privacy Policy. If you do not agree, do not use our Services.</p>
            <hr />
            <ol className="tltermsofuse">
              <li>
                <h2>Acceptance of Terms</h2>
                <p>By using Travelance.ca, you agree to be bound by these Terms of Use, including our Privacy Policy and any additional legal notices, disclaimers, or guidelines posted on our website. If you are using the Services on behalf of an organization, you represent and warrant that you are authorized to bind that organization.</p>
              </li>
              <li>
                <h2>Eligibility</h2>
                <p>You must be the age of majority in your jurisdiction and legally capable of entering into contracts to use our Services. Our Services are intended for Canadian residents and international visitors seeking insurance products in Canada.</p>
              </li>
              <li>
                <h2>Broker and User Accounts</h2>
                <p>Certain portions of Travelance.ca are accessible only to registered brokers who log in with verified credentials. Brokers are responsible for maintaining the confidentiality of their account information and are liable for all activity under their account.</p>
                <p> Travelance reserves the right to suspend or terminate accounts that violate these Terms or applicable law.</p>
              </li>
              <li>
                <h2>Use of Website and Services</h2>
                <p> You may use the Services only for lawful purposes and in accordance with these Terms. You agree not to:</p>
                <ul>
                  <li>Attempt unauthorized access to any part of the Services.</li>
                  <li>Interfere with the proper working of the site or its security.</li>
                  <li>Use bots or automated systems to scrape data or access content.</li>
                </ul>
                <p> Travelance may modify, suspend, or discontinue any part of the Services at any time without liability.</p>
              </li>
              <li>
                <h2>Insurance Quote & Policy Information</h2>
                <p>Quotes provided through our platform are <b>non-binding estimates</b> based on information you provide and do not constitute insurance coverage. All applications are subject to underwriting approval and final confirmation by the insurance provider.</p>
                <p>We offer insurance products both directly and through our underwriters, including <b>Zurich Insurance Company Ltd (Canadian Branch)</b> and <b>Old Republic Insurance Company of Canada</b> .</p>
              </li>
              <li>
                <h2>Intellectual Property & Copyright</h2>
                <p>All content on Travelance.ca &mdash; including text, logos, graphics, software, downloads, and digital tools is owned by or licensed to Travelance and protected by Canadian and international copyright and trademark laws.</p>
                <p> You may not reproduce, modify, publish, or distribute our content without prior written permission, except for personal, non-commercial use with all proprietary notices intact.</p>
              </li>
              <li>
                <h2>User Content & Reviews</h2>
                <p>By submitting reviews or feedback, you grant Travelance a non-exclusive, worldwide, royalty-free license to use, reproduce, display, and publish such content. You agree not to post content that is false, defamatory, or violates any third-party rights.</p>
                <p> Travelance may moderate or remove content at its sole discretion.</p>
              </li>
              <li>
                <h2>Third-Party Integrations & APIs</h2>
                <p>Our Services integrate with third-party platforms, including payment processors (e.g., <b>Converge</b>) and API services. We are not responsible for the functionality, content, or data practices of third-party services.</p>
                <p>Your use of such services is governed by their respective terms.</p>
              </li>
              <li>
                <h2>Downloadable Content</h2>
                <p>Downloadable tools and content are provided for user convenience. You may only use these materials in accordance with these Terms and any license agreements accompanying them. Unauthorized reproduction or distribution is prohibited.</p>
              </li>
              <li>
                <h2>Limitation of Liability</h2>
                <p>To the fullest extent permitted by law, Travelance Inc. shall not be liable for any <b>indirect, incidental, consequential, special, punitive, or exemplary damages</b>, including loss of data, profits, or use.</p>
                <p> Total aggregate liability under these Terms shall not exceed the amount paid by you for Services in the prior 12 months.</p>
              </li>
              <li>
                <h2>Disclaimer of Warranties</h2>
                <p>Travelance provides the Services "<b>as is</b>" and disclaims all warranties of any kind, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
                <p> We do not guarantee uninterrupted access, accuracy, or completeness of the Services.</p>
              </li>
              <li>
                <h2>Indemnification</h2>
                <p>You agree to defend, indemnify, and hold harmless Travelance and its affiliates, officers, agents, and employees from and against any claims, losses, damages, and expenses arising out of your use of the Services or violation of these Terms.</p>
              </li>
              <li>
                <h2>Privacy & Data Collection</h2>
                <p>We collect and process user data including names, emails, health information, and IP addresses as described in our <b>Privacy Policy</b>. By using our Services, you consent to the collection, use, and disclosure of your information in accordance with that policy.</p>
              </li>
              <li>
                <h2>DMCA Compliance</h2>
                <p>Travelance complies with the <b>Digital Millennium Copyright Act (DMCA)</b>. If you believe that your copyrighted work has been infringed, please follow the notice and takedown procedures outlined in our Terms and Conditions.</p>
              </li>
              <li>
                <h2>Governing Law & Jurisdiction</h2>
                <p>These Terms shall be governed by the laws of <b>Ontario, Canada</b>. Any legal proceedings shall be brought exclusively in the courts of <b>Ontario</b>.</p>
              </li>
              <li>
                <h2>Arbitration Agreement</h2>
                <p>If a dispute arises that cannot be resolved through good faith negotiation, it shall be settled by <b>binding arbitration</b> in accordance with the rules of the <b>Canadian Arbitration Association</b>. Each party waives any right to a jury trial.</p>
              </li>
              <li>
                <h2>Changes to Terms</h2>
                <p>Travelance reserves the right to change or update these Terms at any time without prior notice. Continued use of the Services after changes constitutes acceptance of the new Terms. Users are encouraged to check this page regularly.</p>
              </li>
              <li>
                <h2>Contact Information</h2>
                <p>If you have any questions regarding this Terms of Use, please contact us using this form: <a href="https://www.travelance.ca/contact/">www.travelance.ca/contact/</a> or by email to <a href="mailto:admin@travelance.ca">admin@travelance.ca</a>.</p>
              </li>
            </ol>
            <p><b>Effective Date:</b> May 20, 2022</p>
            <p><b>Last Updated:</b> June 04, 2025</p>
          </div>
        </div>
      </div>
    </div>
    <Footer lang="en" />
    </>
  );
}

export default TermsOfUse;
